export default class CarouselBlocks {
    constructor() {
        this.carouselBlocks = document.querySelectorAll('.fd-block-carousel');
        this.init();
    }

    init() {
        if (this.carouselBlocks.length) {
            this.carouselBlocks.forEach((elt, index) => {
                const swiperAuthorList = elt.querySelector('.list-auteurs');
                const swiperProductList = elt.querySelector('.list-products');


                if (swiperAuthorList) {
                    const pagination = elt.querySelector('.swiper-pagination');
                    pagination.id = `swiper-pagination-${index}`;

                    const swiper = new Swiper(swiperAuthorList, {
                        slidesPerView: 1,
                        centeredSlides: false,
                        spaceBetween: 15,
                        grabCursor: true,
                        dynamicBullets: true,
                        pagination: {
                            el: `#swiper-pagination-${index}`,
                            type: 'bullets',
                            clickable: true,
                        },
                        navigation: {
                            nextEl: elt.querySelector('.swiper-next'),
                            prevEl: elt.querySelector('.swiper-prev'),
                        },
                        breakpoints: {
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            1024: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            1280: {
                                slidesPerView: 3,
                                spaceBetween: 30,
                            },
                        },
                    });


                    swiper.on('slideChange', function () {
                        const activeIndex = swiper.realIndex;
                        const bullets = pagination.querySelectorAll('.swiper-pagination-bullet');

                        bullets.forEach((bullet) => bullet.classList.remove('swiper-pagination-bullet-active'));

                        if (bullets[activeIndex]) {
                            bullets[activeIndex].classList.add('swiper-pagination-bullet-active');
                        }
                    });
                }

                if (swiperProductList) {
                    const pagination = elt.querySelector('.swiper-pagination');
                    pagination.id = `swiper-pagination-${index}`;

                    const swiper = new Swiper(swiperProductList, {
                        slidesPerView: 1,
                        centeredSlides: false,
                        spaceBetween: 15,
                        grabCursor: true,
                        dynamicBullets: true,
                        pagination: {
                            el: `#swiper-pagination-${index}`,
                            type: 'bullets',
                            clickable: true,
                        },
                        navigation: {
                            nextEl: elt.querySelector('.swiper-next'),
                            prevEl: elt.querySelector('.swiper-prev'),
                        },
                        breakpoints: {
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            1024: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            1280: {
                                slidesPerView: 3,
                                spaceBetween: 30,
                            },
                        },
                    });


                    swiper.on('slideChange', function () {
                        const activeIndex = swiper.realIndex;
                        const bullets = pagination.querySelectorAll('.swiper-pagination-bullet');

                        bullets.forEach((bullet) => bullet.classList.remove('swiper-pagination-bullet-active'));

                        if (bullets[activeIndex]) {
                            bullets[activeIndex].classList.add('swiper-pagination-bullet-active');
                        }
                    });
                }

            });
        }
    }
}
